(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('sellersSection', sellersSection);

    /* @ngInject */
    function sellersSection() {
        var directive = {
            bindToController: true,
            templateUrl: 'sellers-section.tpl',
            controller: sellersSectionController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '=',
                searchModel: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            if (window.location.hash && (window.location.hash == '#teams')) {
                scope.vm.currentTab = 'teams-list';
            } else {
                scope.vm.currentTab = 'sellers-list';
            }
        }
    }

    /* @ngInject */
    function sellersSectionController ($scope) {
        $scope.vm.inEdit = false;
    }
})();